export default __webpack_public_path__ + "static/media/spinner.fe43b466.gif";